import React, { useMemo } from 'react';
import { useBookingWizard } from 'core/contexts/bookingWizard';
import { Field, useFormState } from 'react-final-form';
import { Box, Button, Grid2 } from '@mui/material';
import { ArrowBack, ArrowForward } from '@mui/icons-material';
import { PhoneNumber, Textarea, TextInput } from '@utriper/core-ui';
import { Title, Container, Label } from '../../styles';

const TriperForm = ({ form }) => {
    const { handleNext, handleBack } = useBookingWizard();
    const { errors } = useFormState();
    const hasError = useMemo(() => Object.keys(errors || {}).length > 0, [errors]);

    const handleMobilePhone = (value, countryCode) => {
        form.batch(() => {
            form.change('mobilePhone', value);
            form.change('mobilePhoneCountryCode', countryCode);
        });
    };

    return (
        // pb: the surrounding form is height 100%, so its own padding is not after a step that overflows it.
        <Box component="section" sx={{ width: '100%', maxWidth: '640px', placeSelf: 'center', pb: 2 }}>
            <Title title="Información del viajero" description="Ingresa los datos del viajero que realiza esta reserva." />

            {/* Form */}
            <Grid2 container width="100%" direction="column" justifyContent="flex-start" alignItems="flex-start" gap="8px" mt="24px">
                <Container>
                    <Label>Nombre</Label>
                    <Field
                        name="firstName"
                        component={TextInput}
                        placeholder="Juan"
                        slotProps={{
                            input: {
                                inputProps: {
                                    maxLength: 255,
                                },
                            },
                        }}
                    />
                </Container>

                <Container>
                    <Label>Apellido</Label>
                    <Field
                        name="lastName"
                        component={TextInput}
                        placeholder="Peréz"
                        slotProps={{
                            input: {
                                inputProps: {
                                    maxLength: 255,
                                },
                            },
                        }}
                    />
                </Container>

                <Container>
                    <Label>Email</Label>
                    <Field
                        name="email"
                        component={TextInput}
                        placeholder="juan.perez@ejemplo.com"
                        slotProps={{
                            input: {
                                inputProps: {
                                    maxLength: 255,
                                },
                            },
                        }}
                    />
                </Container>

                <Container>
                    <Label>Número de teléfono</Label>
                    <Field name="mobilePhone" component={PhoneNumber} onChange={handleMobilePhone} />
                </Container>

                <Container>
                    <Label>{'Información extra (opcional)'}</Label>
                    <Field name="additional" component={Textarea} placeholder="Cualquier información o solicitud especial..." minRows={2} />
                </Container>

                <Container>
                    <Label>{'Vendedor (opcional)'}</Label>
                    <Field
                        name="hostAgent"
                        component={TextInput}
                        placeholder="Nombre del vendedor"
                        slotProps={{
                            input: {
                                inputProps: {
                                    maxLength: 255,
                                },
                            },
                        }}
                    />
                </Container>
            </Grid2>

            <Grid2 container justifyContent="center" alignItems="center" gap="32px" mt="32px" flexWrap="nowrap">
                <Button
                    sx={{
                        border: '1px solid #13131340',
                        color: '#131313',
                        width: '100%',
                        textTransform: 'none',
                        fontWeight: 700,
                        py: '8px',
                    }}
                    startIcon={<ArrowBack />}
                    variant="outlined"
                    onClick={handleBack}
                >
                    Anterior
                </Button>
                <Button
                    sx={{
                        backgroundColor: 'var(--color-utriper-blue)',
                        width: '100%',
                        color: 'white',
                        textTransform: 'none',
                        fontWeight: 700,
                        py: '8px',
                    }}
                    endIcon={<ArrowForward />}
                    variant="contained"
                    onClick={handleNext}
                    disabled={hasError}
                >
                    Siguiente
                </Button>
            </Grid2>
        </Box>
    );
};

export default TriperForm;
